import React from 'react'
import { Link } from 'react-router-dom'
import Paginate from 'components/paginate'
import {Search} from 'components/common'
import {SimpleBanner} from './banner'


export default class EventsPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			events: [],
			page_count: 24,
			f_search: null
		};
		//this.events_all = [];
	}

	/*
	componentDidMount() {
		http.get('/home/getDynamicContent.json?type=events', {}, response => {
			this.setState({ events: response.data });
			response.data.forEach(m => {
				m.search = m.name.normalize().toLowerCase();
			});
			this.events_all = response;
		});
	}
*/
	filter(name, value) {
		this.setState({f_search: value || null});
		/*
		this.state[name] = value;
		const { f_search } = this.state;
		const events = this.events_all.filter(n => (
			(!f_search || n.search.indexOf(f_search) >= 0)
		));
		this.setState({events: events})
		*/
	}

	render() {
		return (
			<div className="news">
				<SimpleBanner title={__('socials_events')} />
				<div className="container">
					<div className="row mt-4">
						<div className="col">
							<div className="float-right">
								<div className="input-group input-group-sm mb-3">
									<Search doSearch={value => this.filter('f_search', value)} />
								</div>
							</div>
						</div>
					</div>
					<h5 className="center">{__('socials_events_future')}</h5>
					<div className="row">
						<Paginate
							url={"/home/getDynamicContent.json?category=events".urlify({
								search: this.state.f_search || undefined,
								from: new Date().toJSON()
							})}
							classNameEl="col-xs-12 col-sm-6 col-md-4 pb-4"
							itemsPerPage={this.state.page_count}
							renderItem={event =>
								<Link to={'/home/event/' + event.id} key={event.id} className="item">
									{event.image
										? <img className='img' src={event.image} alt={event.name} />
										: <div className="img" />
									}
									<div className="name">
										<div className="date">
											{event.day} {event.month_year}
										</div>
										<div>
											{event.name}
										</div>
									</div>
								</Link>
							}
							paginationContainer={page_nav =>
								<div key="pc" className="col-sm-12">
									{page_nav}
								</div>
							}
						/>
					</div>
					<hr />
					<h5 className="center">{__('socials_events_past')}</h5>
					<div className="row">
						<Paginate
							url={"/home/getDynamicContent.json?category=events".urlify({
								search: this.state.f_search || undefined,
								until: new Date().toJSON()
							})}
							classNameEl="col-xs-12 col-sm-6 col-md-4 pb-4"
							itemsPerPage={this.state.page_count}
							renderItem={event =>
								<Link to={'/home/event/' + event.id} key={event.id} className="item">
									{event.image
										? <img className='img' src={event.image} alt={event.name} />
										: <div className="img" />
									}
									<div className="name">
										<div className="date">
											{event.day} {event.month_year}
										</div>
										<div>
											{event.name}
										</div>
									</div>
								</Link>
							}
							paginationContainer={page_nav =>
								<div key="pc" className="col-sm-12 pagination-container">
									{page_nav}
								</div>
							}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export class EventPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {}
		this.componentWillReceiveProps(props);
	}

	componentWillReceiveProps(props) {
		const { match } = props;
		this.state.item_id = match && match.params.eid ? match.params.eid : 0;
		this.state.titled = match && match.params.titled ? match.params.titled : 0;
		if (this.state.item_id) {
			http.get('/home/getDynamicContent.json', {id: this.state.item_id}, response => {
				this.setState({item: response.event})
			})
		}
	}

	render() {
		if (!this.state.item) {
			return null;
		}
		const {item, titled} = this.state
		return (
			<div>
				<SimpleBanner title={titled ? item.name : __('socials_events')} />
				<div className="container-fluid">
					<div className="row justify-content-center mt-4">
						<div className="col-sm col-md-8 dyn-content">
							<h5>{titled == 0 && item.name ? (item.published_at + ' ' + item.name) : null}</h5>
							{item.img && !item.href ? <img src={item.img} alt={item.name} /> : null}
							{item.href
								? <a href={item.href || null} target='_blank'>
									<img src={item.img} alt={item.name} />
								  </a>
								: null}
							<div className="content" dangerouslySetInnerHTML={{__html: item.body}}></div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
